module.exports = __webpack_public_path__ + "static/undraw_newsletter_vovu.021b9d94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/graphics/undraw_newsletter_vovu.svg
// module id = 139
// module chunks = 222457311475995 276467848923518